import React from 'react';
import { connect } from 'react-redux';
import propTypes from 'prop-types';
import {
  setBreadcrumbs,
  reduceServerErrors,
  ConfirmChangesModal,
  UiToastAdapter,
} from 'src/ui';
import { MuiTitle } from 'src/ui/mui-ui-kit';;
import { ClientSidePagingManager } from 'src/api';
import { impersonateAccount } from 'src/user';
import { toast } from 'react-toastify';
import { sendBaseMerchantApplication } from 'src/account';
import { makeQuerablePromise } from 'src/ui/util';
import {
  getAccounts,
  fetchAllAccounts,
  fetchAccount,
  fetchFormData,
} from '../redux';
import { AccountsTable } from '../components';
import { ACCOUNT_STATUS } from '../const';
// import { delay } from 'src/ui';

class AccountsForReviewPage extends React.Component {
  state = {
    loading: true,
    accounts: [],
    submittingAccount: false,
    // checkingBaseSubmission: false,
  };

  baseCheckStart = new Date();

  constructor(props) {
    super(props);

    this.pagedAccounts = new ClientSidePagingManager(
      this.props.fetchAllAccounts, // eslint-disable-line react/destructuring-assignment

      () =>
        // eslint-disable-next-line react/destructuring-assignment
        this.props.accounts.items.filter(
          account =>
            [ACCOUNT_STATUS.SUBMITTED, ACCOUNT_STATUS.ACTIVE].includes(
              account.status
            ) && account.hasPayments === true
        ) || [],
      accounts => {
        this.setState({ accounts });
      }
    );
  }

  async componentDidMount() {
    const { setBreadcrumbs } = this.props;
    // let checkingBaseSubmission = false;
    setBreadcrumbs([
      { label: 'Review Accounts', href: '/accounts-for-review' },
    ]);

    await this.pagedAccounts.fetch();

    const { accounts } = this.props;
    if (accounts.isError()) {
      reduceServerErrors(accounts);
    }

    this.setState({ loading: false });
  }

  // async checkBaseSubmission() {
  //   //const { fetchLoggedInUser } = this.props;
  //   var { submittingAccount } = this.state;
  //   const { fetchAccount } = this.props;
  //   this.setState({ checkingBaseSubmission: true });

  //   //Get the account back to see if the date and or id was updated.

  //   var account = await fetchAccount(submittingAccount.id);
  //   //submittingAccount = account(submittingAccount)

  //   if (!account.account_sent_to_base_date && new Date() - this.baseCheckStart < 60000) {
  //     await delay(3000);
  //     return this.checkBaseSubmission();
  //   }

  //   if (account.account_sent_to_base_date  || !submittingAccount) {
  //     this.setState({
  //       checkingBaseSubmission: !!account.account_sent_to_base_date,
  //       submittingAccount: null
  //     });
  //     toast(UiToastAdapter('Application sent. Base Application ID: ', 'info'));
  //   }

  //   return true;
  // }

  onEditAccount = async account => {
    const { impersonateAccount, fetchAccount, fetchFormData } = this.props;
    await impersonateAccount({
      accountId: account.id,
      accountName: account.businessName,
      hasConsents: account.hasConsents,
      hasDocuments: account.hasDocuments,
    });
    await fetchAccount(account.id);
    await fetchFormData(account.financialInstitution.id, account.id);
  };

  onSubmitToBase = account => {
    this.setState({ submittingAccount: account });
  };

  onConfirmSubmit = async () => {
    toast(UiToastAdapter('Sending application to base standby...', 'info'));
    const { submittingAccount } = this.state;
    // Base send stuff
    const currentComponent = this;

    if (!submittingAccount.account_sent_to_base_date) {
      const myPromise = makeQuerablePromise(
        Promise.resolve(
          sendBaseMerchantApplication({ accountId: submittingAccount.id })
        )
      );
      myPromise.then(function(data) {
        if (myPromise.isFulfilled()) {
          if (data.ok && Number.isInteger(data.data)) {
            currentComponent.setState({
              merchantApplicationId: data.data,
              submittingAccount: false,
            });

            toast(
              UiToastAdapter(
                `Application sent successfully. BaseApplicationID: ${data.data}`,
                'success'
              )
            );
          } else if (data.ok) {
            toast(
              UiToastAdapter(
                `Application failed to send. Error: ${data.data}`,
                'danger'
              ),
              { autoClose: false, hideProgressBar: true }
            );
            // toast.error('Application failed to send. Error: ' + data.data,{ hideProgressBar: false, closeOnClick: false, progress: .5, } );
            currentComponent.setState({ submittingAccount: false });
          } else {
            toast(UiToastAdapter('Application failed to send.', 'danger'), {
              autoClose: false,
              hideProgressBar: true,
            });
            currentComponent.setState({ submittingAccount: false });
          }
        } else if (myPromise.Rejected()) {
          toast(UiToastAdapter('Sending to base rejected: ', 'danger'), {
            autoClose: false,
            hideProgressBar: true,
          });
          currentComponent.setState({ submittingAccount: false });
        } else if (myPromise.pending()) {
          toast(UiToastAdapter('Sending to base pending: ', 'danger'), {
            autoClose: false,
            hideProgressBar: true,
          });
          currentComponent.setState({ submittingAccount: false });
        }
      });

      // const mAppId = await Promise(promise);

      // this.setState({ merchantApplicationId: mAppId });
      // this.checkBaseSubmission();
    } else {
      toast(
        UiToastAdapter(
          'Application was already sent. Base Application ID: ',
          'info'
        )
      );
    }
  };

  // sendAppToBase(accountId: submittingAccount.id,)
  // sendBaseMerchantApplication({
  // accountId: submittingAccount.id,
  // });

  // this.setState({ submittingAccount: null });
  // toast(UiToastAdapter('Sending application to base...', 'success'));
  // };

  render() {
    const { loading, accounts, submittingAccount } = this.state;

    return (
      <>
        <MuiTitle isSize="4" hasTextColor="info" tag="h2">
          Awaiting Review & Submission
        </MuiTitle>
        <AccountsTable
          loading={loading}
          accounts={accounts.filter(account => account.base_Id < 1) || []}
          paging={this.pagedAccounts}
          canAddAccount={false}
          onEditAccount={this.onEditAccount}
          onSubmitToBase={this.onSubmitToBase}
        />
        <MuiTitle isSize="4" hasTextColor="info" tag="h2">
          Submitted to Base
        </MuiTitle>
        <AccountsTable
          loading={loading}
          accounts={accounts.filter(account => account.base_Id > 0) || []}
          paging={this.pagedAccounts}
          canAddAccount={false}
          onEditAccount={this.onEditAccount}
        />
        <ConfirmChangesModal
          isActive={!!submittingAccount}
          onClickCancel={() => this.setState({ submittingAccount: null })}
          onClickSubmit={this.onConfirmSubmit}
          text="Are you sure you want to submit the following account to Base?"
          title={submittingAccount.businessName || ''}
        />
      </>
    );
  }
}

AccountsForReviewPage.propTypes = {
  accounts: propTypes.object.isRequired,
  fetchAllAccounts: propTypes.func.isRequired,
  fetchAccount: propTypes.func.isRequired,
  fetchFormData: propTypes.func.isRequired,
  impersonateAccount: propTypes.func.isRequired,
  setBreadcrumbs: propTypes.func.isRequired,
  // sendBaseMerchantApplication: propTypes.func.isRequired,
};

function mapStateToProps(state) {
  return {
    accounts: getAccounts(state),
  };
}

const connectedAccountsForReviewPage = connect(mapStateToProps, {
  setBreadcrumbs,
  fetchAllAccounts,
  impersonateAccount,
  fetchAccount,
  fetchFormData,
})(AccountsForReviewPage);

export { connectedAccountsForReviewPage as AccountsForReviewPage };
